import ElementLocale from "element-ui/lib/locale";
import axios from "axios";

import VueI18n from "vue-i18n";
import Vue from "vue";
import { Notification } from "element-ui";
// import router from "../router";
import langService from "./langService";

Vue.use(VueI18n);

const loadedLanguages = [];
const messages = {};
ElementLocale.i18n(key => i18n.t(key));

const i18n = new VueI18n({
  messages, // set locale messages
  silentTranslationWarn: true
});
function setI18nLanguage(lang) {
  i18n.locale = lang;
  axios.defaults.headers.common["Accept-Language"] = lang;
  document.querySelector("html").setAttribute("lang", lang);
  return lang;
}

export function getLoadedLanguages() {
  return loadedLanguages;
}

export function getNrMessages() {
  if (messages) {
    return 1;
  }
  return 0;
}

Array.prototype.pushDistinct = function(key) {
  if (!(key in this)) {
    this.push(key);
  }
};

export function loadSingleTranslation(lang, code){

    return langService
        .getSingleTranslation(lang,code)
        .then(msg => {
          var msgs = i18n.getLocaleMessage(lang);

          msgs[code] = msg + "";

          i18n.setLocaleMessage(lang, msgs);
        });

}

export function loadLanguageAsync(lang, force = false) {

  console.log("loadLanguageAsync > " + lang);
  console.log("Force > " + force);

  if (force || i18n.locale !== lang) {
    if (force || !loadedLanguages.includes(lang)) {

      return langService
        .getTranslations(lang)
        .then(msgs => {
          i18n.setLocaleMessage(lang, msgs);
          loadedLanguages.pushDistinct(lang);
          
      console.log(i18n.getLocaleMessage(lang));
          return setI18nLanguage(lang);
        })
        .catch(error => {
          console.log(error);
          //Notification.error({
          //  title: "Attenzione",
          //  message: JSON.stringify(error)
          //});
        });
    }
    return Promise.resolve(setI18nLanguage(lang));
  }
  return Promise.resolve(lang);
}

export default i18n;
